import { useTranslation } from "react-i18next";
import Ft20 from "./20Ft";
import Ft20NoSides from "./20FtNoSides";
import Ft20OpenCeiling from "./20FtOpenCeiling";
import Ft20Refrigerator from "./20FtRefrigerator";
import Ft40 from "./40Ft";
import Ft40High from "./40FtHigh";
import Ft40NoSides from "./40FtNoSides";
import Ft40Refrigerator from "./40FtRefrigerator";

const MarinContainers = () => {
  const { t } = useTranslation();
  return (
    <main>
      <article className="py-20">
        <div className="w-11/12 mx-auto">
          <h1 className="text-[24px] my-5 md:text-[32px] font-bold text-mainBlue text-center">
            {t("typesAndSizesOfMarin")}
          </h1>
          <section className="space-y-10">
            <Ft20 />
            <Ft40 />
            <Ft20OpenCeiling />
            <Ft40High />
            <Ft20NoSides />
            <Ft40NoSides />
            <Ft20Refrigerator />
            <Ft40Refrigerator />
          </section>
        </div>
      </article>
    </main>
  );
};

export default MarinContainers;
